import { createFileRoute } from '@tanstack/react-router';

import { AccountLayout } from '../features/account/account-layout';
import { requireSession } from '../features/auth/require-session';

/**
 * `/account/*` 계정 영역 — **세션만** 요구한다 (D146 ② · `AC-PF-01-09`·`18`).
 * 온보딩·동의 게이트 밖이라 필수 동의 전에도 프로필과 로그아웃이 열린다.
 */
export const Route = createFileRoute('/account')({
  beforeLoad: ({ context, location }) =>
    requireSession({ queryClient: context.queryClient, location }).then(() => undefined),
  component: AccountLayout,
});
